import { envConfig } from '#constants/envConfig';

import { GTM } from '../constants/gtm';

const scripts = [
  `
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${GTM.id}');
`,
  `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag("consent", "default", {
        ad_storage: "denied",
        ad_user_data: "denied", 
        ad_personalization: "denied",
        analytics_storage: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
        security_storage: "granted",
        wait_for_update: 1000,
    });
    gtag("set", "ads_data_redaction", true);
    gtag("set", "url_passthrough", true);
      gtag('js', new Date());
    `,
];

/**
 * Empty outside production: the dev stand and the Playwright suite were sending page views and
 * `submit_sign_up_success` into the same GA4 property as real users, so the reports counted test
 * traffic as acquisition. See envConfig.ANALYTICS_ENABLED for how to switch it back on for a build.
 */
export const gtmScripts = envConfig.ANALYTICS_ENABLED ? scripts : [];
